(function () {
    function initTurnkeyStationsSliders() {
        if (typeof window.Swiper !== 'function') return;

        document.querySelectorAll('[data-turnkey-stations-slider]').forEach(function (slider) {
            if (slider.swiper) return;

            const section = slider.closest('.turnkey-stations');
            const pagination = section ? section.querySelector('.turnkey-stations__pagination') : null;
            const previousButton = section ? section.querySelector('.turnkey-stations__arrow--prev') : null;
            const nextButton = section ? section.querySelector('.turnkey-stations__arrow--next') : null;

            new window.Swiper(slider, {
                slidesPerView: 'auto',
                spaceBetween: 6,
                speed: 500,
                watchOverflow: true,
                keyboard: {
                    enabled: true,
                },
                a11y: {
                    enabled: true,
                },
                pagination: {
                    el: pagination,
                    clickable: true,
                },
                navigation: {
                    prevEl: previousButton,
                    nextEl: nextButton,
                },
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTurnkeyStationsSliders);
    } else {
        initTurnkeyStationsSliders();
    }
})();
